var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/gift-card/product-gift-card-calendar.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg version=\"1.1\" class=\"c-date-picker__calendar--icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 180 179\" style=\"enable-background:new 0 0 180 179;\" xml:space=\"preserve\" role=\"img\" aria-hidden=\"true\">\n\n\t<path d=\"M50,86H25V61h25V86z M50,96H25v25h25V96z M50,131H25v25h25V131z M85,61H60v25h25V61z M85,96H60v25h25V96z M85,131H60v25h25\n\t\tV131z M120,61H95v25h25V61z M120,96H95v25h25V96z M120,131H95v25h25V131z M155,61h-25v25h25V61z M155,96h-25v25h25V96z M155,131h-25\n\t\tv25h25V131z M126,27c3.3,0,6-2.7,6-6V6c0-3.3-2.7-6-6-6s-6,2.7-6,6v15C120,24.3,122.7,27,126,27z M110,9H70c0,3,0,7,0,10h40\n\t\tC110,15.5,110,12.7,110,9z M54,27c3.3,0,6-2.7,6-6V6c0-3.3-2.7-6-6-6s-6,2.7-6,6v15C48,24.3,50.7,27,54,27z M180,14v160\n\t\tc0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V14c0-2.8,2.2-5,5-5h33c0,3,0,7,0,10H10v18h160V19h-28c0-3,0-7,0-10h33C177.8,9,180,11.2,180,14\n\t\tz M170,47H10v122h160V47z\">\n\t</path>\n\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/gift-card/product-gift-card-calendar.j2"] , dependencies)